import {
  USER_LIST_FAIL,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_LIST_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_LOCK_FAIL,
  USER_LOCK_REQUEST,
  USER_LOCK_SUCCESS,
  USER_UNLOCK_FAIL,
  USER_UNLOCK_REQUEST,
  USER_UNLOCK_SUCCESS,
} from "../Constants/UserContants";

// LOGIN
export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

// ALL USER
export const userListReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return { loading: true };
    case USER_LIST_SUCCESS:
      return { loading: false, users: action.payload };
    case USER_LIST_FAIL:
      return { loading: false, error: action.payload };
    case USER_LIST_RESET:
      return { users: [] };
    default:
      return state;
  }
};

// USER LOCK
export const userLockReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOCK_REQUEST:
      return { loading: true };
    case USER_LOCK_SUCCESS:
      return { loading: false, success: true };
    case USER_LOCK_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// USER UNLOCK
export const userUnlockReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UNLOCK_REQUEST:
      return { loading: true };
    case USER_UNLOCK_SUCCESS:
      return { loading: false, success: true };
    case USER_UNLOCK_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
